module.exports = __webpack_public_path__ + "img/7.d7c890a4.png";